export { MAX_FILE_BYTES } from '@/lib/file-upload';

export const PAGE_SIZE = 10;

export const STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'voided', label: 'Voided' },
  { value: 'completed', label: 'Completed' },
] as const;


